<footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-12">
				<span class="footer-title">{{commonService?.pages?.title}}</span>
				<div class="footer-voices">
					<div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul  class="voices">
							 <li *ngFor="let elem of commonService?.pages?.sezione1" ><a (click)="navigateTo(elem)" >{{elem.label}}</a></li>
							</ul>
					</div>
					<div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul class="voices">
							 <li *ngFor="let elem of commonService?.pages?.sezione2" ><a (click)="navigateTo(elem)" >{{elem.label}}</a></li>
							</ul>
					</div>
					<div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul class="voices">
							 <li *ngFor="let elem of commonService?.pages?.sezione3"><a (click)="navigateTo(elem)" >{{elem.label}}</a></li>
							</ul>
					</div>
					<div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul class="voices">
							 <li *ngFor="let elem of commonService?.pages?.sezione4"><a (click)="navigateTo(elem)" >{{elem.label}}</a></li>
							</ul>
					</div>
					<!-- <div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul class="voices">
							<li><a [routerLink]="['/cms', 'drafting']">{{'cms.drafting' | translate}}</a></li>
							<li><a [routerLink]="['/cms', 'legal-notes']">{{'cms.legal-notes' | translate}}</a></li>
							<li><a [routerLink]="['/cms', 'privacy']">{{'cms.privacy' | translate}}</a></li>
						</ul>
					</div>
					<div class="col-sm-12 col-md-4 col-lg-3 col-voice">
						<ul class="voices">
							<li><a [routerLink]="['/cms', 'faqs']">{{'cms.faqs' | translate}}</a></li>
						</ul>
					</div> -->
				</div>
				<span class="copyright-Regione">{{'footer.copyright' | translate}}</span>
			</div>
		</div>
	</div>
</footer>